import { BlockContainer } from '@components/blocks/shared/BlockContainer';
import { Title } from '@components/common';
import { Cart } from '@components/features';
import { Box, styled } from '@mui/material';

// STYLES
//--------
const CartBlockBox = styled(Box)``;

// TYPES
//--------

export type CartBlockProps = {
  title?: string;
};

export const CartBlock = ({ title }: CartBlockProps) => {
  return (
    <BlockContainer>
      <CartBlockBox>
        {title && (
          <Box sx={{ mb: { xs: 2, md: 6 } }}>
            <Title variant='h2'>{title}</Title>
          </Box>
        )}
        <Cart />
      </CartBlockBox>
    </BlockContainer>
  );
};
